import { useEffect, useState } from 'react';
import Button from '../../common/Button';
import './ScheduleForm.scss';

function ScheduleForm({ userData, onSubmit, onCancel, isLoading, data }) {
  const [formData, setFormData] = useState({
    frequency: 'daily',
    hour: '9',
    minute: '0',
    dayOfWeek: '1', // Monday
    dayOfMonth: '1',
    timezone: 'Etc/UTC',
    docType: 'commissions',
  });

  useEffect(() => {
      setFormData(data.selectedSchedule ? { ...data.selectedSchedule } : {});
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Helper to build CRON string from formData
  const buildCron = () => {
    const { frequency, minute, hour, dayOfWeek, dayOfMonth } = formData;
    if (frequency === 'hourly') {
      return `${minute} * * * *`;
    } else if (frequency === 'daily') {
      return `${minute} ${hour} * * *`;
    } else if (frequency === 'weekly') {
      return `${minute} ${hour} * * ${dayOfWeek}`;
    } else if (frequency === 'monthly') {
      return `${minute} ${hour} ${dayOfMonth} * *`;
    }
    return '* * * * *';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const cron = buildCron();
    onSubmit({
      docType: formData.docType,
      schedule: cron,
      timezone: formData.timezone,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="add-credential-form">
      <div className="form-group">
        <label>Doc Type</label>
        <select name="docType" value={formData.docType} onChange={handleChange} disabled={isLoading}>
          <option value="commissions">Commissions</option>
        </select>
      </div>
      <div className="form-group">
        <label>Frequency</label>
        <select name="frequency" value={formData.frequency} onChange={handleChange} disabled={isLoading}>
          <option value="hourly">Hourly</option>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>
      {(formData.frequency === 'daily' || formData.frequency === 'weekly' || formData.frequency === 'monthly') && (
        <div className="form-group">
          <label>Hour</label>
          <input
            type="number"
            name="hour"
            min="0"
            max="23"
            value={formData.hour}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
        </div>
      )}
      {(formData.frequency === 'hourly' || formData.frequency === 'daily' || formData.frequency === 'weekly' || formData.frequency === 'monthly') && (
        <div className="form-group">
          <label>Minute</label>
          <input
            type="number"
            name="minute"
            min="0"
            max="59"
            value={formData.minute}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
        </div>
      )}
      {formData.frequency === 'weekly' && (
        <div className="form-group">
          <label>Day of Week</label>
          <select name="dayOfWeek" value={formData.dayOfWeek} onChange={handleChange} disabled={isLoading}>
            <option value="0">Sunday</option>
            <option value="1">Monday</option>
            <option value="2">Tuesday</option>
            <option value="3">Wednesday</option>
            <option value="4">Thursday</option>
            <option value="5">Friday</option>
            <option value="6">Saturday</option>
          </select>
        </div>
      )}
      {formData.frequency === 'monthly' && (
        <div className="form-group">
          <label>Day of Month</label>
          <input
            type="number"
            name="dayOfMonth"
            min="1"
            max="31"
            value={formData.dayOfMonth}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
        </div>
      )}
      { userData?.can_schedule && <div className="form-actions">
        <Button 
          type="button" 
          className="normal cancel-btn" 
          label="Cancel" 
          onClick={onCancel}
          disabled={isLoading}
        />
        <Button 
          type="submit" 
          className="normal submit-btn" 
          label={data?.mode || 'Create'}
          isLoading={isLoading}
        />
      </div> }
    </form>
  );
}

export default ScheduleForm;
